import {
  Box,
  HStack,
  KdsButton,
  KdsCardFile,
  KdsEmptyContent,
  KdsText,
  VStack,
} from "@kazaar-platform/design-system";
import { RiAddCircleLine } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { useState } from "react";
import { useToasts } from "@/hooks";
import { useFile } from "@/hooks/queries/useFile";
import { ModalAddExtraAttachmentForm } from "@/modals/ModalAddExtraAttachmentForm/ModalAddExtraAttachment";
import { type ExtraAttachmentsBlocProps } from "./ExtraAttachmentsBloc.types";

export const ExtraAttachmentsBloc = ({
  orderItem,
}: ExtraAttachmentsBlocProps) => {
  const { t } = useTranslate();
  const { add } = useToasts();

  const { useDownloadFileHandler } = useFile();
  const { handleDownloadFile } = useDownloadFileHandler();

  const [isOpenAddExtraAttachment, setIsOpenAddExtraAttachment] =
    useState(false);

  const extraAttachments = orderItem?.sandboxItem?.extraAttachments;

  return (
    <Box w="100%" rounded="br-md" bgColor="elevation.first" p="sp-md">
      <VStack gap="sp-md">
        <HStack justify="space-between">
          <KdsText size="title-sm">
            {t("order.myOrdersItemDetails.extraAttachments")}
          </KdsText>

          {extraAttachments?.length && (
            <KdsButton
              variant="outlined"
              color="neutral"
              onPress={() => setIsOpenAddExtraAttachment(true)}
              iconLeft={RiAddCircleLine}
            >
              {t("buttons.addAttachment")}
            </KdsButton>
          )}
        </HStack>

        <Box maxH="450px" overflowY="auto">
          <VStack gap="sp-md">
            {extraAttachments?.length ? (
              extraAttachments.map((extraAttachment) => (
                <KdsCardFile
                  key={extraAttachment.url}
                  fileName={extraAttachment.fileName}
                  fileSize={extraAttachment.size}
                  fileUrl={extraAttachment.url}
                  isViewable
                  isDownloadable
                  onDownload={() =>
                    handleDownloadFile(
                      extraAttachment.fileName,
                      extraAttachment.url
                    )
                  }
                />
              ))
            ) : (
              <KdsEmptyContent
                title={t("documentEmptyState.title")}
                description={t("documentEmptyState.subtitle")}
                linkProps={{
                  href: "#",
                  children: t("buttons.addAttachment"),
                  onPress: () => setIsOpenAddExtraAttachment(true),
                  size: "md",
                }}
              />
            )}
          </VStack>
        </Box>
      </VStack>

      <ModalAddExtraAttachmentForm
        isOpen={isOpenAddExtraAttachment}
        orderId={orderItem?.orderId}
        orderItemId={orderItem.id}
        setOpenState={setIsOpenAddExtraAttachment}
        addToast={add}
        sandboxItemId={orderItem?.sandboxItem?.id}
      />
    </Box>
  );
};
